<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="specialties.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Nova Especialidade",
          routerName: "RegisterSpecialty",
        },
      ],
      specialties: {
        name: "",
      },
      specialtiesParams: this.$route.params,
      selectedCategory: "",
      dataProps: { module: "Professional" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      specialtiesData: "Professional/specialties",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Professional", [
      "registerSpecialties",
      "consultSpecialties",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.specialties?.id
        ? "Especialidade editado com sucesso!"
        : "Especialidade cadastrado com sucesso!";

      await this.registerSpecialties(this.specialties);
      this.$router.push({ name: "ListSpecialties" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.specialtiesParams &&
      Object.keys(this.specialtiesParams).length > 0
    ) {
      await this.consultSpecialties(this.specialtiesParams);
      this.dataProps = {
        name: this.specialtiesData.name,
        id: this.specialtiesParams.id,
        module: "Professional",
        type: "Specialty",
      };
      this.specialties = this.specialtiesData;
      this.links[1].name = this.specialties.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
